// Only currencies Paystack actually supports
const CURRENCY_MAP: Record<string, { symbol: string; code: string }> = {
  GH: { symbol: '₵',   code: 'GHS' },  // Ghana
  NG: { symbol: '₦',   code: 'NGN' },  // Nigeria
  KE: { symbol: 'KSh', code: 'KES' },  // Kenya
  ZA: { symbol: 'R',   code: 'ZAR' },  // South Africa
  US: { symbol: '$',   code: 'USD' },   // United States
  GB: { symbol: '£',   code: 'GBP' },  // United Kingdom
};

// Everyone else pays in USD
const DEFAULT_CURRENCY = { symbol: '$', code: 'USD' };

let cachedCurrency: { symbol: string; code: string } | null = null;

export async function getUserCurrency(): Promise<{ symbol: string; code: string }> {
  if (cachedCurrency) return cachedCurrency;

  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    const countryCode = data.country_code as string;
    cachedCurrency = CURRENCY_MAP[countryCode] || DEFAULT_CURRENCY;
  } catch {
    cachedCurrency = DEFAULT_CURRENCY;
  }

  return cachedCurrency;
}

export function formatPrice(amount: number, symbol: string): string {
  return `${symbol}${amount}`;
}
